import EntityModel from '@/common/models/entity-model';

export default class GatewayModel extends EntityModel {
    hydrate({
        response = null,
        avsResponse = null,
        cvvResponse = null,
    } = {}) {
        if (response) {
            this.response = {};
            this.response.code = response.code;
            this.response.message = response.message;
            this.response.type = response.type;
            this.response.originalCode = response.originalCode;
            this.response.originalMessage = response.originalMessage;
        }
        if (avsResponse) {
            this.avsResponse = {};
            this.avsResponse.code = avsResponse.code;
            this.avsResponse.message = avsResponse.message;
            this.avsResponse.type = avsResponse.type;
            this.avsResponse.originalCode = avsResponse.originalCode;
            this.avsResponse.originalMessage = avsResponse.originalMessage;
        }
        if (cvvResponse) {
            this.cvvResponse = {};
            this.cvvResponse.code = cvvResponse.code;
            this.cvvResponse.message = cvvResponse.message;
            this.cvvResponse.type = cvvResponse.type;
            this.cvvResponse.originalCode = cvvResponse.originalCode;
            this.cvvResponse.originalMessage = cvvResponse.originalMessage;
        }
    }
}
